const SESSION_KEY = 'eclipse_session';
const IMPERSONATION_KEY = 'eclipse_impersonation';

const dispatchTenantChanged = () =>
  window.dispatchEvent(new Event('eclipse:tenant-changed'));

export const getSession = () => {
  try {
    const base = JSON.parse(localStorage.getItem(SESSION_KEY)) || {};
    const imp = getImpersonation();
    if (imp) return { ...base, tenantId: imp.tenantId };
    return base;
  } catch {
    return {};
  }
};

export const setSession = (data) => {
  localStorage.setItem(SESSION_KEY, JSON.stringify(data));
  dispatchTenantChanged();
};

export const clearSession = () => {
  localStorage.removeItem(SESSION_KEY);
};

export const getImpersonation = () => {
  try {
    return JSON.parse(localStorage.getItem(IMPERSONATION_KEY)) || null;
  } catch {
    return null;
  }
};

export const setImpersonation = (data) => {
  localStorage.setItem(IMPERSONATION_KEY, JSON.stringify(data));
  dispatchTenantChanged();
};

export const clearImpersonation = () => {
  localStorage.removeItem(IMPERSONATION_KEY);
  dispatchTenantChanged();
};
